<template>
  <!-- 添加文件类型弹窗 -->
    <el-dialog
    title="文件类型"
    :visible="isShowType"
    @close='close' width='500px'
    :destroy-on-close="true"
    :close-on-click-modal='false'>
      <el-table
        ref="addTable"
        class="global-table"
        v-loading="loading"
        :data="tableData"
        max-height="357">
        <el-table-column label="类型名称" prop="typesName" min-width="150" align='center'>
          <template slot-scope = "{ row, $index }">
            <div v-if='row.typeId'>
              <template v-if="$index === addLine">
                <el-input v-model="info.typesName" maxlength="10" placeholder="请输入类型名称"></el-input>
              </template>
              <p v-else>{{row.typesName}}</p>
            </div>
            <template v-else>
              <el-input v-model="info.typesName" maxlength="10" placeholder="请输入类型名称"></el-input>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="时间节点" prop="timeNode" min-width="150" align='center'>
          <template slot-scope = "{ row, $index }">
            <div v-if='row.typeId'>
              <template v-if="$index === addLine">
                <el-select
                  v-model="info.timeNode"
                  placeholder="请选择时间节点"
                  filterable
                >
                  <el-option
                    v-for="item in nodeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </template>
              <p v-else>{{nodeList[Number(row.timeNode) - 1].label || ''}}</p>
            </div>
            <template v-else>
              <el-select
                v-model="info.timeNode"
                placeholder="请选择时间节点"
                filterable
              >
                <el-option
                  v-for="item in nodeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="100" align='center'>
          <template slot-scope="{ row, $index}">
            <template v-if='row.typeId'>
              <el-button type="text" @click="addUpdate($index, row)">{{$index === addLine ?"保存" : "编辑" }}</el-button>
              <el-button type="text" v-if="$index !== addLine" @click="onDelete(row)">删除</el-button>
            </template>
            <template v-else>
              <el-button type="text" @click="addUpdate($index, row)">保存</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: center" class="mt20 mb20"><el-button type="primary" @click='addFormNew()' icon='el-icon-plus'>新增</el-button></div>
    </el-dialog>
</template>

<script>
export default {
  name: 'List',
  props: {
    isShowType: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      addLine: '',
      tableData: [],
      loading: false,
      info: '',
      nodeList: [
        {
          label: '项目进场前',
          value: '1'
        },
        {
          label: '施工作业中',
          value: '2'
        },
        {
          label: '验收完成',
          value: '3'
        },
        {
          label: '审计定案',
          value: '4'
        }
      ]
    }
  },
  computed: {
    initAddForm () {
      return {
        typesName: '',
        timeNode: '',
        typeId: ''
      }
    }
  },
  watch: {
    isShowType (value) {
      return value && this.getTypeList()
    }
  },
  created () {
    this.info = this.initAddForm
  },
  methods: {
    getTypeList () {
      this.loading = true
      this.$axios.get(this.$apis.projectFile.selectYhProjectFileTypesByList).then(res => {
        this.tableData = res || []
      }).finally(() => {
        this.loading = false
      })
    },
    addUpdate (index, row) {
      if (this.addLine === index) {
        if (!this.info.typesName) {
          this.$message.warning('请输入文件类型名称')
          return
        }
        if (!this.info.timeNode) {
          this.$message.warning('请选择时间节点')
          return
        }
        const url = this.info.typeId ? this.$apis.projectFile.updateYhProjectFileTypes : this.$apis.projectFile.insertYhProjectFileTypes
        this.$axios.post(url, this.info).then(() => {
          this.$message.success(this.info.typeId ? '编辑文件类型成功' : '添加文件类型成功')
          this.addLine = null
          this.info = JSON.parse(JSON.stringify(this.initAddForm))
          this.getTypeList()
        })
      } else if (this.addLine !== null) {
        this.$message.warning('请先保存')
      } else {
        this.addLine = index
        this.info = { ...row }
      }
    },
    addFormNew () {
      if (!this.addLine && this.addLine !== 0) {
        this.info = JSON.parse(JSON.stringify(this.initAddForm))
        this.tableData.push(this.info)
        this.addLine = this.tableData.length - 1
        // 滚动到表格最底部
        this.$nextTick(() => {
          (this.$refs.addTable).bodyWrapper.scrollTop = (this.$refs.addTable).bodyWrapper.scrollHeight
        })
      } else {
        this.$message.warning('请先保存')
      }
    },
    onDelete (row) {
      this.$confirm(`是否删除文件类型【${row.typesName}】?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.projectFile.deleteYhProjectFileTypes,
          {
            typeId: row.typeId
          }).then(() => {
          this.$message.success('删除成功')
          this.addLine = null
          this.getTypeList()
        })
      })
    },
    close () {
      // 数据清除
      this.addLine = null
      this.$emit('onClose')
      this.$emit('update:isShowType', false)
    }
  }
}
</script>

<style scoped lang="scss">
</style>
